import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { messages } from '../localization/validationMessage/en.json'
import i18n from '../localization/lang/i18n'

import { languages } from '../localization/lang/languages'

import helper from './helper'
// import tr from "vue2-datepicker/locale/es/tr";

Object.keys(rules).forEach((rule) => {
	extend(rule, {
		...rules[rule], // copies rule configuration
		message: messages[rule], // assign message
	})
})

extend('required', {
	...rules['required'],
	message: () => mappingValidateMessage(i18n.locale, 'validate.requiredField'),
})

extend('email', {
	...rules['email'],
	message: () => mappingValidateMessage(i18n.locale, 'validate.email'),
})

extend('phoneNumber', {
	validate: (value) => {
		var phoneRegex = /^\d+$/

		return phoneRegex.test(value)
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.phoneNumber'),
})

extend('checked', {
	validate: (value) => {
		return value
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.checked'),
})

extend('currencyPayIn', {
	validate: (value) => {
		let now = new Date().toISOString().slice(0, 10)
		let maxDay = helper.addDays(now, 30).toISOString().slice(0, 10)
		if (value < now || value > maxDay) {
			return false
		}
		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.currencyPayIn'),
})

extend('dayBeforeToday', {
	validate: (value) => {
		let now = new Date().toISOString().slice(0, 10)
		return value <= now
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.dayBeforeToday'),
})

extend('appSelectRequired', {
	validate: (value) => {
		return !isNaN(value)
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.appSelectRequired'),
})

extend('bmi', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.bmi'),
})

extend('cms', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		if (value > 300 || value <= 0) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.cms'),
})

extend('feets', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		if (value > 9 || value < 0) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.feets'),
})

extend('inches', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		if (value > 11 || value < 0) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.inches'),
})

extend('kgs', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		if (value > 300 || value < 1) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.kgs'),
})

extend('pounds', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		if (value > 13 || value < 0) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.pounds'),
})

extend('stones', {
	validate: (value) => {
		if (isNaN(value)) {
			return false
		}

		if (value > 47 || value < 0) {
			return false
		}

		return true
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.stones'),
})

extend('genderId', {
	validate: (value) => {
		return !isNaN(value)
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.genderId'),
})

extend('occupationId', {
	validate: (value) => {
		return !isNaN(value)
	},
	message: () => mappingValidateMessage(i18n.locale, 'validate.occupationId'),
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

const mappingValidateMessage = (locale, lngKey) => {
	const values = []

	if (locale == null) locale = 'en'
	values.push(
		[languages['en']].concat(lngKey.split('.')).reduce(function (a, b) {
			return a[b]
		}),
	)

	if (locale !== 'en') {
		values.push(
			[languages[locale]].concat(lngKey.split('.')).reduce(function (a, b) {
				return a[b]
			}),
		)
	}

	return values.join('<br>')
}
